import React from 'react';
// Core components
import Avatar from 'components/core/Avatar';
// Models
import mParkingCategory from 'models/cpm/parkingCategory';
// Custom
import { cpmParkingCategoryDataShape } from 'constants/PropTypesShapes';

const ParkingCategoryIcon = ({ parkingCategory }) => (
  <Avatar backgroundColor={mParkingCategory.color(parkingCategory)} size={20} variant="rounded">
    <div />
  </Avatar>
);

ParkingCategoryIcon.propTypes = {
  parkingCategory: cpmParkingCategoryDataShape.isRequired,
};

module.exports = ParkingCategoryIcon;



// WEBPACK FOOTER //
// ./routes/cpm/routes/carparks/assets/parkingCategories/ParkingCategoryIcon.js